// Manifiesto de temas: la única fuente de verdad del proyecto.
//
// Añadir un análisis nuevo es una entrada en este array (ver SKILLS.md): la
// portada (periodico/Portada.jsx) y el archivo (periodico/Expedientes.jsx) lo mapean a una tarjeta y el router (App.js)
// lo mapea a una ruta con React.lazy(load). No se editan a mano ni la landing
// ni el router para sumar, quitar o reordenar temas: solo se toca este archivo.
//
// Cada tema declara:
//   id        identificador estable
//   slug      nombre corto en la URL
//   path      ruta de react-router (`/<slug>`)
//   titulo    nombre del análisis
//   subtitulo una línea que lo describe
//   etiqueta  rótulo de categoría (mono, en mayúsculas)
//   accent    color de acento del tema (hex)
//   fuentes   procedencia en texto corto
//   publicado fecha de publicación (YYYY-MM-DD). La portada ordena por este
//             campo, de más reciente a más antiguo. NO es `meta.actualizado`
//             del dataset: aquel se mueve con cada /refrescar y haría saltar
//             expedientes viejos al primer puesto. Se fija una vez, al crear
//             el tema, y ya no se toca.
//   en        traducción inglesa de titulo/subtitulo/etiqueta/fuentes (opcional; sin ella
//             la tarjeta sale en español). Ver ops/i18n/PLAN.md.
//   load      import dinámico del .jsx del tema
//
// El array es APPEND-ONLY: los temas nuevos se añaden al final y la portada
// los coloca en su sitio según `publicado`. No hace falta reordenar a mano.

const temas = [
  {
    id: "convocatoria-11j",
    slug: "convocatoria-11j",
    path: "/convocatoria-11j",
    titulo: "Mañana es 11J",
    subtitulo:
      "Quinto aniversario del 11J: dónde y a qué hora sale el mundo a la calle por Cuba, con cada convocatoria en su nivel de verificación",
    etiqueta: "CONVOCATORIA · 11 DE JULIO",
    accent: "#32BD4E", // verde señal de la paleta "Luz verde" del renderer congelado
    fuentes: "Prensa independiente cubana · Prisoners Defenders · Justicia 11J · OCDH",
    dataSlug: "convocatoria_11j", // el dataset es /data/convocatoria_11j.json (guion bajo)
    publicado: "2026-07-10",
    en: {
      titulo: "Tomorrow is 11J",
      subtitulo:
        "Fifth anniversary of 11J: where and when the world takes to the streets for Cuba, with each call to protest rated by its level of verification",
      etiqueta: "CALL TO PROTEST · JULY 11",
      fuentes: "Independent Cuban press · Prisoners Defenders · Justicia 11J · OCDH",
    },
    load: () => import("./convocatoria_11j.jsx"),
  },
  {
    id: "anatomia-11j",
    slug: "anatomia-11j",
    path: "/anatomia-11j",
    titulo: "La anatomía de la represión del 11J",
    subtitulo: "Quién pagó el precio de salir a la calle el 11 de julio de 2021",
    etiqueta: "REPRESIÓN · HISTORIA", // ⚠ CONFIRMAR
    accent: "#E3A52A",                // ⚠ CONFIRMAR (marigold dominante en la paleta)
    fuentes: "Justicia 11J / Cubalex", // ⚠ CONFIRMAR
    dataSlug: "11j", // el dataset es /data/11j.json, no /data/anatomia-11j.json
    publicado: "2026-06-30",
    en: {
      titulo: "Anatomy of the 11J crackdown",
      subtitulo:
        "Who paid the price for taking to the streets on July 11, 2021",
      etiqueta: "REPRESSION · HISTORY",
      fuentes: "Justicia 11J / Cubalex",
    },
    load: () => import("./anatomia_11j.jsx"),
  },
  {
    id: "angola",
    slug: "angola",
    path: "/angola",
    titulo: "Cuba en Angola: la sangre y el negocio",
    subtitulo:
      "Medio siglo de una misma operación: el ejército (1975-1991) y los médicos (2007-hoy); quién cobró, quién pagó y cuántos no volvieron",
    etiqueta: "EXPEDIENTE · INTERNACIONALISMO",
    accent: "#6E9537", // oliva "Carlota" del renderer congelado
    fuentes: "Archivo Cuba (verificado) · Gleijeses · elTOQUE · Connectas · prensa independiente",
    publicado: "2026-07-11",
    en: {
      titulo: "Cuba in Angola: blood and business",
      subtitulo:
        "Half a century of the same operation: the army (1975-1991) and the doctors (2007-today); who got paid, who paid, and how many never came back",
      etiqueta: "INVESTIGATION · INTERNATIONALISM",
      fuentes: "Archivo Cuba (verified) · Gleijeses · elTOQUE · Connectas · independent press",
    },
    load: () => import("./angola.jsx"),
  },
  {
    id: "represion",
    slug: "represion",
    path: "/represion",
    titulo: "La maquinaria de la represión",
    subtitulo: "Observatorio de la represión en Cuba · foco abril–mayo 2026",
    etiqueta: "REPRESIÓN · DERECHOS HUMANOS",
    accent: "#C4392B",
    fuentes: "OCDH · Prisoners Defenders · prensa independiente cubana",
    publicado: "2026-06-30",
    en: {
      titulo: "The machinery of repression",
      subtitulo:
        "Observatory of repression in Cuba · focus April–May 2026",
      etiqueta: "REPRESSION · HUMAN RIGHTS",
      fuentes: "OCDH · Prisoners Defenders · independent Cuban press",
    },
    load: () => import("./represion_cuba.jsx"),
  },
  {
    id: "conflictos",
    slug: "conflictos",
    path: "/conflictos",
    titulo: "La calle arde",
    subtitulo: "Observatorio de la protesta cívica en Cuba · primer trimestre de 2026",
    etiqueta: "PROTESTA CÍVICA · OCC",
    accent: "#F2913B",
    fuentes: "Observatorio Cubano de Conflictos (OCC)",
    publicado: "2026-06-30",
    en: {
      titulo: "The streets are burning",
      subtitulo:
        "Observatory of civic protest in Cuba · first quarter of 2026",
      etiqueta: "CIVIC PROTEST · OCC",
      fuentes: "Observatorio Cubano de Conflictos (OCC)",
    },
    load: () => import("./conflictos_cuba.jsx"),
  },
  {
    id: "gaesa",
    slug: "gaesa",
    path: "/gaesa",
    titulo: "Energía y GAESA",
    subtitulo:
      "El coste de los apagones frente a los activos líquidos del conglomerado militar",
    etiqueta: "ENERGÍA · CONTRAFACTUAL",
    accent: "#38D6C9",
    fuentes: "Escenario del autor sobre cifras públicas",
    publicado: "2026-06-30",
    en: {
      titulo: "Energy and GAESA",
      subtitulo:
        "The cost of the blackouts versus the liquid assets of the military conglomerate",
      etiqueta: "ENERGY · COUNTERFACTUAL",
      fuentes: "Author's scenario based on public figures",
    },
    load: () => import("./gaesa-escenario.jsx"),
  },
  {
    id: "rusificacion",
    slug: "rusificacion",
    path: "/rusificacion",
    titulo: "La rusificación de Cuba",
    subtitulo: "Mapa de la captura oligárquica del Estado",
    etiqueta: "RED DE PODER",
    accent: "#D4AE57",
    fuentes: "Periodismo de investigación y documentos oficiales",
    publicado: "2026-06-30",
    en: {
      titulo: "The Russification of Cuba",
      subtitulo:
        "Mapping the oligarchic capture of the State",
      etiqueta: "POWER NETWORK",
      fuentes: "Investigative journalism and official documents",
    },
    load: () => import("./rusificacion_cuba.jsx"),
  },
  {
    id: "himno",
    slug: "himno",
    path: "/himno",
    titulo: "Himno Patriótico Cubano",
    subtitulo: "El himno de Narciso López · 1850",
    etiqueta: "HISTORIA · SÍMBOLOS PATRIOS", // ⚠ CONFIRMAR
    accent: "rgb(80, 133, 230)",                        // ⚠ CONFIRMAR (oro de la partitura / la estrella)
    fuentes: "BNF/Gallica · Gay-Calbó (1945) · Heredia",  // ⚠ CONFIRMAR
    publicado: "2026-06-30",
    en: {
      titulo: "Cuban Patriotic Hymn",
      subtitulo:
        "Narciso López's anthem · 1850",
      etiqueta: "HISTORY · NATIONAL SYMBOLS",
      fuentes: "BNF/Gallica · Gay-Calbó (1945) · Heredia",
    },
    load: () => import("./himno_narciso.jsx"),
  },
  {
    id: "mineria",
    slug: "mineria",
    path: "/mineria",
    titulo: "El subsuelo y la crisis",
    subtitulo: "Reservas minerales de Cuba y la ruptura geopolítica de 2026",
    etiqueta: "RECURSOS MINERALES · GEOPOLÍTICA",
    accent: "#f54b08",
    fuentes: "USGS · Sherritt NI 43-101 · Antilles Gold JORC · GeoMinera",
    publicado: "2026-06-30",
    en: {
      titulo: "The subsoil and the crisis",
      subtitulo:
        "Cuba's mineral reserves and the geopolitical rupture of 2026",
      etiqueta: "MINERAL RESOURCES · GEOPOLITICS",
      fuentes: "USGS · Sherritt NI 43-101 · Antilles Gold JORC · GeoMinera",
    },
    load: () => import("./mineria.jsx"),
  },
  {
    id: "libertad-prensa",
    slug: "libertad-prensa",
    path: "/libertad-prensa",
    titulo: "El cerco a la palabra",
    subtitulo: "Violaciones a la libertad de expresión y de prensa en Cuba — enero de 2026.",
    etiqueta: "LIBERTAD DE PRENSA · ICLEP", // ⚠ CONFIRMAR
    accent: "#2BB6A6",                       // ⚠ CONFIRMAR (turquesa del eyebrow)
    fuentes: "ICLEP · Instituto Cubano por la Libertad de Expresión y Prensa", // ⚠ CONFIRMAR
    dataSlug: "iclep", // el dataset es /data/iclep.json, no /data/libertad-prensa.json
    publicado: "2026-06-30",
    en: {
      titulo: "Silencing the word",
      subtitulo:
        "Violations of freedom of expression and of the press in Cuba — January 2026.",
      etiqueta: "PRESS FREEDOM · ICLEP",
      fuentes: "ICLEP · Instituto Cubano por la Libertad de Expresión y Prensa",
    },
    load: () => import("./iclep.jsx"),
  },
  {
    id: "racismo-estructural",
    slug: "racismo-estructural",
    path: "/racismo-estructural",
    titulo: "El racismo que el Estado niega",
    subtitulo: "Represión racializada de defensores afrodescendientes en Cuba — y sus ecos históricos.",
    etiqueta: "REPRESIÓN · RACISMO ESTRUCTURAL", // ⚠ CONFIRMAR
    accent: "#A33B4A",                            // ⚠ CONFIRMAR (garnet del título; alt: ochre #C9803E del eyebrow)
    fuentes: "Informe alternativo CERD 2026 · CRD · 4Métrica · Ciudadanía y Libertad", // ⚠ CONFIRMAR
    dataSlug: "racismo", // el dataset es /data/racismo.json, no /data/racismo-estructural.json
    publicado: "2026-06-30",
    en: {
      titulo: "The racism the State denies",
      subtitulo:
        "Racialized repression of Afro-descendant human rights defenders in Cuba — and its historical echoes.",
      etiqueta: "REPRESSION · STRUCTURAL RACISM",
      fuentes: "CERD 2026 alternative report · CRD · 4Métrica · Ciudadanía y Libertad",
    },
    load: () => import("./racismo.jsx"),
  },
  {
    id: "asesinatos-masacres",
    slug: "asesinatos-masacres",
    path: "/asesinatos-masacres",
    titulo: "Asesinatos y masacres de Estado",
    subtitulo: "Ejecuciones, hundimientos y muertes en huelga de hambre bajo el Estado cubano · 1959–2022",
    etiqueta: "MEMORIA · CRÍMENES DE ESTADO",
    accent: "#3F92B0",
    fuentes: "Archivo Cuba / Free Society Project · Proyecto de Verdad y Memoria",
    publicado: "2026-07-05",
    en: {
      titulo: "State killings and massacres",
      subtitulo:
        "Executions, sinkings and hunger-strike deaths under the Cuban State · 1959–2022",
      etiqueta: "MEMORY · STATE CRIMES",
      fuentes: "Archivo Cuba / Free Society Project · Proyecto de Verdad y Memoria",
    },
    load: () => import("./asesinatos_masacres.jsx"),
  },
  {
    id: "desaparecidos-2023",
    slug: "desaparecidos-2023",
    path: "/desaparecidos-2023",
    titulo: "Los 79 de 2023",
    subtitulo: "Muertes y desapariciones documentadas en 2023 atribuidas al Estado cubano",
    etiqueta: "MEMORIA · VERDAD Y MEMORIA 2023",
    accent: "#FF6A00",
    fuentes: "Archivo Cuba & American Museum of the Cuban Diaspora · Verdad y Memoria",
    publicado: "2026-07-05",
    en: {
      titulo: "The 79 of 2023",
      subtitulo:
        "Deaths and disappearances documented in 2023 attributed to the Cuban State",
      etiqueta: "MEMORY · TRUTH AND MEMORY 2023",
      fuentes: "Archivo Cuba & American Museum of the Cuban Diaspora · Verdad y Memoria",
    },
    load: () => import("./desaparecidos_2023.jsx"),
  },
  {
    id: "servicio-militar",
    slug: "servicio-militar",
    path: "/servicio-militar",
    titulo: "Servir o morir",
    subtitulo: "El servicio militar obligatorio en Cuba: trata de personas con un costo letal",
    etiqueta: "DERECHOS · SERVICIO MILITAR",
    accent: "#33C27A",
    fuentes: "Maria C. Werlau · Archivo Cuba / Free Society Project",
    publicado: "2026-07-05",
    en: {
      titulo: "Serve or die",
      subtitulo:
        "Compulsory military service in Cuba: human trafficking with a deadly cost",
      etiqueta: "RIGHTS · MILITARY SERVICE",
      fuentes: "Maria C. Werlau · Archivo Cuba / Free Society Project",
    },
    load: () => import("./servicio_militar.jsx"),
  },
  {
    id: "vias-cambio",
    slug: "vias-cambio",
    path: "/vias-cambio",
    titulo: "Vías de cambio: invasión, ley y evidencia",
    subtitulo: "Qué dice la evidencia sobre cómo caen los regímenes: resistencia civil, invasión de exiliados e intervención directa de una potencia",
    etiqueta: "VÍAS DE CAMBIO · EVIDENCIA",
    accent: "#157A72", // teal "voltaje" de la paleta congelada del renderer
    fuentes: "Chenoweth & Stephan (NAVCO) · Downes & Monten · Carta ONU y AGNU · CEPAL · Horizonte Cubano (Columbia Law)",
    dataSlug: "vias_cambio", // el dataset es /data/vias_cambio.json (guion bajo), no /data/vias-cambio.json
    publicado: "2026-07-05",
    en: {
      titulo: "Paths to change: invasion, law and evidence",
      subtitulo:
        "What the evidence says about how regimes fall: civil resistance, exile invasion and direct intervention by a foreign power",
      etiqueta: "PATHS TO CHANGE · EVIDENCE",
      fuentes: "Chenoweth & Stephan (NAVCO) · Downes & Monten · UN Charter and UNGA · ECLAC · Horizonte Cubano (Columbia Law)",
    },
    load: () => import("./vias_cambio.jsx"),
  },
  {
    id: "electrica",
    slug: "electrica",
    path: "/electrica",
    titulo: "La corriente interrumpida",
    subtitulo: "El sistema eléctrico cubano: de la electrificación de la isla al apagón permanente",
    etiqueta: "ENERGÍA · SISTEMA ELÉCTRICO NACIONAL",
    accent: "#3BA9E0", // azul de arco de la paleta "Arco voltaico" del renderer congelado
    fuentes: "Unión Eléctrica (UNE) · Horizonte Cubano (Columbia Law) · IEEE Spectrum · ONEI · prensa independiente",
    publicado: "2026-07-07",
    en: {
      titulo: "The interrupted current",
      subtitulo:
        "Cuba's power grid: from the electrification of the island to permanent blackout",
      etiqueta: "ENERGY · NATIONAL POWER GRID",
      fuentes: "Unión Eléctrica (UNE) · Horizonte Cubano (Columbia Law) · IEEE Spectrum · ONEI · independent press",
    },
    load: () => import("./electrica.jsx"),
  },
  {
    id: "medidas-176",
    slug: "medidas-176",
    path: "/medidas-176",
    titulo: "Las 176 medidas: anatomía de un ciclo",
    subtitulo:
      "Sesenta y seis años de aperturas anunciadas y reversiones ejecutadas, medidos contra los países que no revirtieron",
    etiqueta: "ECONOMÍA · CONTRAFACTUAL", // ⚠ CONFIRMAR
    accent: "#35C4A6",                     // ⚠ CONFIRMAR (menta "apertura" de la paleta del renderer)
    fuentes: "Maddison Project · CEPAL/FMI · Gacetas Oficiales · documento de las 176 medidas", // ⚠ CONFIRMAR
    dataSlug: "medidas_176", // el dataset es /data/medidas_176.json (guion bajo)
    publicado: "2026-07-14",
    en: {
      titulo: "The 176 measures: anatomy of a cycle",
      subtitulo:
        "Sixty-six years of announced openings and enforced reversals, measured against the countries that did not reverse course",
      etiqueta: "ECONOMY · COUNTERFACTUAL",
      fuentes: "Maddison Project · ECLAC/IMF · Official Gazettes · the 176-measures document",
    },
    load: () => import("./medidas_176.jsx"),
  },
  {
    id: "triana",
    slug: "triana",
    path: "/triana",
    titulo: "Triana en cifras",
    subtitulo:
      "Anatomía de una entrevista reformista: dónde acierta, dónde falla la aritmética y a quién se deja de nombrar",
    etiqueta: "ECONOMÍA · FACT-CHECK", // ⚠ CONFIRMAR
    accent: "#e9b23c",                  // ⚠ CONFIRMAR (oro dominante de la paleta del renderer)
    fuentes: "La Joven Cuba (entrevista) · Reuters · The Guardian · Wikipedia", // ⚠ CONFIRMAR
    dataSlug: "triana_reformas", // el dataset es /data/triana_reformas.json
    publicado: "2026-07-14",
    en: {
      titulo: "Triana by the numbers",
      subtitulo:
        "Anatomy of a reformist interview: where it gets it right, where the arithmetic fails, and who goes unnamed",
      etiqueta: "ECONOMY · FACT-CHECK",
      fuentes: "La Joven Cuba (interview) · Reuters · The Guardian · Wikipedia",
    },
    load: () => import("./triana_reformas.jsx"),
  },
  {
    id: "envejecimiento",
    slug: "envejecimiento",
    path: "/envejecimiento",
    titulo: "El rápido envejecimiento poblacional y la diáspora en Cuba",
    subtitulo:
      "Cómo el éxodo migratorio deformó la pirámide poblacional cubana, comparado con un escenario sin él",
    etiqueta: "DEMOGRAFÍA · DIÁSPORA",
    accent: "#A666D6", // violeta "Nido vacío" del renderer congelado
    fuentes: "ONEI · CBP · Naciones Unidas (World Population Prospects) · Albizu-Campos · ASIC",
    publicado: "2026-07-20",
    en: {
      titulo: "Rapid population ageing and the diaspora in Cuba",
      subtitulo:
        "How the migratory exodus distorted Cuba's population pyramid, compared with a scenario without it",
      etiqueta: "DEMOGRAPHY · DIASPORA",
      fuentes: "ONEI · CBP · United Nations (World Population Prospects) · Albizu-Campos · ASIC",
    },
    load: () => import("./envejecimiento.jsx"),
  },
  {
    id: "cayo-romano",
    slug: "cayo-romano",
    path: "/cayo-romano",
    titulo: "Cayo Romano vs Fondo Soberano Minero",
    subtitulo:
      "Qué vale de verdad el subsuelo cubano, y qué se cede a perpetuidad: el plan C40 medido contra un fondo soberano",
    etiqueta: "RECURSOS · CONTRAFACTUAL", // ⚠ CONFIRMAR
    accent: "#0E7C7B",                     // ⚠ CONFIRMAR (teal de la paleta C del renderer)
    fuentes: "USGS · Reuters · Antilles Gold · DevTech/Crespin · MovimientoC40", // ⚠ CONFIRMAR
    publicado: "2026-07-20",
    en: {
      titulo: "Cayo Romano vs a Sovereign Mining Fund",
      subtitulo:
        "What Cuba's subsoil is really worth, and what is handed over in perpetuity: the C40 plan measured against a sovereign fund",
      etiqueta: "RESOURCES · COUNTERFACTUAL",
      fuentes: "USGS · Reuters · Antilles Gold · DevTech/Crespin · MovimientoC40",
    },
    load: () => import("./cayo_romano.jsx"),
  },
  {
    id: "coraje-dividido",
    slug: "coraje-dividido",
    path: "/coraje-dividido",
    titulo: "Coraje dividido",
    subtitulo: "El valor de un pueblo y la fragmentación de su exilio, medidos",
    etiqueta: "EDICIÓN ESPECIAL · EXILIO", // ⚠ CONFIRMAR
    accent: "#C2497F",                      // ⚠ CONFIRMAR (magenta "exilio" de la paleta del renderer)
    fuentes: "elTOQUE · FIU Cuba Poll · Bendixen & Amandi/Miami Herald · OCC · Justicia 11J · 14ymedio", // ⚠ CONFIRMAR
    dataSlug: "coraje_dividido", // el dataset es /data/coraje_dividido.json (guion bajo)
    publicado: "2026-07-20",
    en: {
      titulo: "Divided courage",
      subtitulo:
        "The courage of a people and the fragmentation of its exile, measured",
      etiqueta: "SPECIAL EDITION · EXILE",
      fuentes: "elTOQUE · FIU Cuba Poll · Bendixen & Amandi/Miami Herald · OCC · Justicia 11J · 14ymedio",
    },
    load: () => import("./coraje_dividido.jsx"),
  },
  {
    id: "desacreditacion",
    slug: "desacreditacion",
    path: "/desacreditacion",
    titulo: "La maquinaria de desacreditar",
    subtitulo:
      "Cómo se fabrica el descrédito de un opositor cubano: etiquetado coordinado, patologización pseudo-clínica y hostigamiento mediático, desde el oficialismo y desde el propio exilio.",
    etiqueta: "DISCURSO · TÁCTICAS DE REPRESIÓN",
    accent: "#AB69A8",
    fuentes: "Cubalex · ICLEP · CiberCuba · 14ymedio · Amnesty International · HRW · Freedom House",
    publicado: "2026-07-22",
    en: {
      titulo: "The discrediting machine",
      subtitulo:
        "How the discrediting of a Cuban dissident is manufactured: coordinated labelling, pseudo-clinical pathologizing and media harassment, from official circles and from within the exile itself.",
      etiqueta: "DISCOURSE · REPRESSION TACTICS",
      fuentes: "Cubalex · ICLEP · CiberCuba · 14ymedio · Amnesty International · HRW · Freedom House",
    },
    load: () => import("./desacreditacion.jsx"),
  },
  {
    id: "sucesion",
    slug: "sucesion",
    path: "/sucesion",
    titulo: "Sucesión sin urnas",
    subtitulo:
      "Tres hombres, un aparato: cómo se ha transferido el poder en Cuba desde 1959 — y por qué un hilo viral que lo explica con teología y psicología usa la herramienta equivocada.",
    etiqueta: "HISTORIA INSTITUCIONAL · PODER",
    accent: "#969933",
    fuentes: "Actas del PCC · ABC News · France24 · CNBC · Rotter (1966) · Weber (1904-05) · Redalyc/SciELO · Dialnet",
    publicado: "2026-07-22",
    en: {
      titulo: "Succession without ballots",
      subtitulo:
        "Three men, one apparatus: how power has been transferred in Cuba since 1959 — and why a viral thread explaining it through theology and psychology uses the wrong tool.",
      etiqueta: "INSTITUTIONAL HISTORY · POWER",
      fuentes: "PCC records · ABC News · France24 · CNBC · Rotter (1966) · Weber (1904-05) · Redalyc/SciELO · Dialnet",
    },
    load: () => import("./sucesion.jsx"),
  },
  {
    id: "protesta-solitaria",
    slug: "protesta-solitaria",
    path: "/protesta-solitaria",
    titulo: "Protestar solo",
    subtitulo:
      "El caso de Javier Ernesto Martín Gutiérrez, campeón cubano de MMA encarcelado tras nueve días de protesta pacífica frente a su casa, y el cargo de \"desórdenes públicos\" usado contra manifestantes solitarios en Cuba entre 2024 y 2026.",
    etiqueta: "REPRESIÓN · CRIMINALIZACIÓN DE LA PROTESTA",
    accent: "#6C60BE", // indigo "Vigilia y Sumario" del renderer congelado
    fuentes: "14ymedio · Martí Noticias · CiberCuba · Diario de Cuba · ICLEP · Prisoners Defenders",
    dataSlug: "protesta_solitaria", // el dataset es /data/protesta_solitaria.json (guion bajo)
    publicado: "2026-07-26",
    en: {
      titulo: "Protesting alone",
      subtitulo:
        "The case of Javier Ernesto Martín Gutiérrez, a Cuban MMA champion jailed after nine days of peaceful protest outside his home, and the \"public disorder\" charge used against lone protesters in Cuba between 2024 and 2026.",
      etiqueta: "REPRESSION · CRIMINALIZATION OF PROTEST",
      fuentes: "14ymedio · Martí Noticias · CiberCuba · Diario de Cuba · ICLEP · Prisoners Defenders",
    },
    load: () => import("./protesta_solitaria.jsx"),
  },
  {
    id: "sulmira",
    slug: "sulmira",
    path: "/sulmira",
    titulo: "La voz que le prestaron",
    subtitulo:
      "Sulmira Martínez Pérez, \"Salem Cuba\", 21-22 años, condenada a 5 años de prisión por memes y llamados pacíficos a protestar en Facebook: la autoinculpación forzada que la televisión estatal transmitió como si fuera su propia voz.",
    etiqueta: "REPRESIÓN · PRESOS POLÍTICOS",
    accent: "#4E7A44",
    fuentes: "Prisoners Defenders · Cubalex · Alas Tensas · ICLEP · CiberCuba · Diario de Cuba",
    publicado: "2026-07-27",
    en: {
      titulo: "The voice they lent her",
      subtitulo:
        "Sulmira Martínez Pérez, \"Salem Cuba\", aged 21-22, sentenced to 5 years in prison for memes and peaceful calls to protest on Facebook: the forced self-incrimination that state television broadcast as if it were her own voice.",
      etiqueta: "REPRESSION · POLITICAL PRISONERS",
      fuentes: "Prisoners Defenders · Cubalex · Alas Tensas · ICLEP · CiberCuba · Diario de Cuba",
    },
    load: () => import("./sulmira.jsx"),
  },
  {
    id: "normas",
    slug: "normas",
    path: "/normas",
    titulo: "Reconstruir la norma",
    subtitulo:
      "Marginalidad, desciudadanización y las condiciones materiales del cambio cívico en Cuba",
    etiqueta: "SOCIEDAD · CULTURA CÍVICA",
    accent: "#2E9B87", // petróleo, color dominante del renderer congelado
    fuentes: "Literatura experimental sobre normas sociales (Science · PNAS · J-PAL) · OCDE · Banco Mundial · OCDH · Rojas · Pedraza",
    dataSlug: "reconstruccion-civica", // el dataset es /data/reconstruccion-civica.json
    publicado: "2026-07-28",
    en: {
      titulo: "Rebuilding the norm",
      subtitulo:
        "Marginality, the stripping of citizenship and the material conditions for civic change in Cuba",
      etiqueta: "SOCIETY · CIVIC CULTURE",
      fuentes: "Experimental literature on social norms (Science · PNAS · J-PAL) · OECD · World Bank · OCDH · Rojas · Pedraza",
    },
    load: () => import("./reconstruccion_civica.jsx"),
  },
  {
    id: "auditar",
    slug: "auditar",
    path: "/auditar",
    titulo: "Auditar a los aliados",
    subtitulo:
      "Evaluación crítica de la Propuesta para transformar la economía cubana",
    etiqueta: "ECONOMÍA · EVALUACIÓN DE PROPUESTAS",
    // El primario del renderer es bermellón #E8462C (h8), pero como accent de
    // portada queda a 3 grados de represion (#C4392B, h5) y cae en el rojo
    // reservado a represión por CLAUDE.md §4. El magenta de la misma paleta
    // (#C765A8, h319) tampoco sirve: queda a 16 grados de desacreditacion
    // (#AB69A8) y a 14 de #C2497F. Se usa el hueco real mayor de la rueda,
    // 48 grados libres entre h200 y h248. El bermellón se queda en la página.
    accent: "#4A63C8",
    fuentes: "ONEI · CEPAL · FMI · elTOQUE · EIU · Cuba Study Group",
    dataSlug: "propuesta-economica-auditoria", // el dataset es /data/propuesta-economica-auditoria.json
    publicado: "2026-07-28",
    en: {
      titulo: "Auditing the allies",
      subtitulo:
        "A critical assessment of the Proposal to transform the Cuban economy",
      etiqueta: "ECONOMY · POLICY ASSESSMENT",
      fuentes: "ONEI · ECLAC · IMF · elTOQUE · EIU · Cuba Study Group",
    },
    load: () => import("./propuesta_economica_auditoria.jsx"),
  },
  {
    id: "cascada",
    slug: "cascada",
    path: "/cascada",
    titulo: "Del subsuelo al fondo: cuánto vale realmente el níquel cubano",
    subtitulo:
      "Anclaje empírico del multiplicador VAN/in-situ a partir del único activo minero cubano con estudio de factibilidad auditado",
    etiqueta: "MINERÍA · VALORACIÓN DE ACTIVOS", // ⚠ CONFIRMAR
    // Confirmado 29-jul-2026 al asentar la ficha en ops/design_log.json: acero
    // desaturado h235 (S30/L58), el único hueco libre del círculo (26°, entre
    // himno h218 y protesta-solitaria h248). Vecino del azul-bandera reservado
    // por CLAUDE.md §4, del que se separa por menos de la mitad de saturación.
    // La laterita #B1723E de la cascada NO sale a portada: se queda dentro.
    accent: "#7479B4",
    fuentes: "Informe técnico NI 43-101 del Moa JV (Micon International · CIM 2014)", // ⚠ CONFIRMAR
    dataSlug: "cascada-valor-minero", // el dataset es /data/cascada-valor-minero.json
    publicado: "2026-07-29",
    en: {
      titulo: "From subsoil to fund: what Cuban nickel is really worth",
      subtitulo:
        "Empirical anchoring of the NPV/in-situ multiplier from the only Cuban mining asset with an audited feasibility study",
      etiqueta: "MINING · ASSET VALUATION",
      fuentes: "Moa JV NI 43-101 technical report (Micon International · CIM 2014)",
    },
    load: () => import("./cascada-valor-minero.jsx"),
  },
  {
    id: "fondo",
    slug: "fondo",
    path: "/fondo",
    titulo: "El fondo que aún no existe",
    subtitulo:
      "Marco para la creación de cualquier fondo soberano en una Cuba democrática",
    etiqueta: "EDICIÓN ESPECIAL · MARCO NORMATIVO", // ⚠ CONFIRMAR
    // Bronce oliva h73 (S30/L44), primario de la paleta del renderer. El círculo
    // está saturado: el margen real son 11° con sucesion (#969933, h62) y 12°
    // con angola (#6E9537, h85). Se separa de ambos por saturación (S30 frente
    // a S50 y S46). La ciruela #9B65A4 del renderer NO sale a portada.
    accent: "#83924F", // ⚠ CONFIRMAR
    fuentes: "NRGI · Transparencia Venezuela · Alaska Permanent Fund · fallos comparados (Alaska · Timor-Leste · Venezuela · Kazajistán)", // ⚠ CONFIRMAR
    dataSlug: "marco-fondo-soberano", // el dataset es /data/marco-fondo-soberano.json
    publicado: "2026-07-29",
    en: {
      titulo: "The fund that does not yet exist",
      subtitulo:
        "A framework for creating any sovereign fund in a democratic Cuba",
      etiqueta: "SPECIAL EDITION · REGULATORY FRAMEWORK",
      fuentes: "NRGI · Transparencia Venezuela · Alaska Permanent Fund · comparative failures (Alaska · Timor-Leste · Venezuela · Kazakhstan)",
    },
    load: () => import("./marco-fondo-soberano.jsx"),
  },
  {
    id: "angel-veliz",
    slug: "angel-veliz",
    path: "/angel-veliz",
    titulo: "Movido tres veces, aliviado ninguna",
    subtitulo:
      "Ángel Jesús Véliz Marcano, preso del 11J en Camagüey, condenado a 6 años de prisión: tres traslados carcelarios entre 2021 y 2024, ninguno hacia el régimen de mínima severidad que le habría acercado a la libertad condicional, mientras su madre, exiliada desde 2024, ya no puede comunicarse con él por teléfono.",
    etiqueta: "REPRESIÓN · PRESOS POLÍTICOS",
    accent: "#71397F",
    fuentes: "Prisoners Defenders · CiberCuba · Cubanet · Diario de Cuba · Diario Las Américas · Martí Noticias · ADN Cuba",
    dataSlug: "angel_veliz", // el dataset es /data/angel_veliz.json (guion bajo)
    publicado: "2026-07-31",
    en: {
      titulo: "Moved three times, relieved none",
      subtitulo:
        "Ángel Jesús Véliz Marcano, an 11J prisoner in Camagüey sentenced to 6 years in prison: three prison transfers between 2021 and 2024, none to the minimum-security regime that would have brought him closer to parole, while his mother, in exile since 2024, can no longer reach him by phone.",
      etiqueta: "REPRESSION · POLITICAL PRISONERS",
      fuentes: "Prisoners Defenders · CiberCuba · Cubanet · Diario de Cuba · Diario Las Américas · Martí Noticias · ADN Cuba",
    },
    load: () => import("./angel_veliz.jsx"),
  },
  {
    id: "militarizacion",
    slug: "militarizacion",
    path: "/militarizacion",
    titulo: "Guerra sin declarar",
    subtitulo:
      "Desde el 17 de enero de 2026, estructuras militares gobiernan funciones civiles en Cuba sin que el Estado haya proclamado ninguna de las situaciones excepcionales que prevé su propia Constitución: 215 eventos documentados por Cubalex entre febrero y julio, un civil procesado por espionaje ante un tribunal militar y amenazas de muerte contra presos políticos.",
    etiqueta: "ESTADO Y DERECHO · MILITARIZACIÓN",
    accent: "#4D4068",
    fuentes: "Cubalex · CiberCuba · Martí Noticias · Diario de Cuba · 14ymedio · CubaNet · OCC",
    publicado: "2026-08-15",
    en: {
      titulo: "Undeclared war",
      subtitulo:
        "Since January 17, 2026, military structures have run civilian functions in Cuba without the State proclaiming any of the states of exception provided for in its own Constitution: 215 events documented by Cubalex between February and July, a civilian tried for espionage before a military court, and death threats against political prisoners.",
      etiqueta: "STATE AND LAW · MILITARIZATION",
      fuentes: "Cubalex · CiberCuba · Martí Noticias · Diario de Cuba · 14ymedio · CubaNet · OCC",
    },
    load: () => import("./militarizacion.jsx"),
  },
  {
    id: "derechos_sociales",
    slug: "derechos_sociales",
    path: "/derechos_sociales",
    titulo: "Julio sin tregua",
    subtitulo:
      "En julio de 2026, zonas periféricas de La Habana cumplieron tres meses sin agua potable, el sistema eléctrico colapsó por completo al menos tres veces y Cubalex contó nueve feminicidios, la cifra más alta de su serie mensual. El propio informe describe julio como el mes de mayor violencia ciudadana desde 2022 — pero, a diferencia de los feminicidios, esa cifra total no ha sido confirmada por una segunda fuente.",
    etiqueta: "DERECHOS SOCIALES · JULIO 2026",
    accent: "#3A5F4D",
    fuentes: "Cubalex · Cubanet · Alas Tensas · Diario de Cuba · 14ymedio · CiberCuba · Infobae · OnCubaNews",
    publicado: "2026-08-15",
    en: {
      titulo: "July without respite",
      subtitulo:
        "In July 2026, outlying areas of Havana went three months without drinking water, the power grid collapsed completely at least three times, and Cubalex counted nine femicides, the highest figure in its monthly series. The report itself describes July as the month with the most violence against citizens since 2022 — but, unlike the femicides, that overall figure has not been confirmed by a second source.",
      etiqueta: "SOCIAL RIGHTS · JULY 2026",
      fuentes: "Cubalex · Cubanet · Alas Tensas · Diario de Cuba · 14ymedio · CiberCuba · Infobae · OnCubaNews",
    },
    load: () => import("./derechos_sociales.jsx"),
  },
  {
    id: "cerco_julio",
    slug: "cerco_julio",
    path: "/cerco_julio",
    titulo: "El cerco de julio",
    subtitulo:
      "El 2 de julio de 2026, la Seguridad del Estado desplegó un operativo simultáneo contra activistas en varias provincias para impedirles asistir a un acto de la Embajada de Estados Unidos. Tres defensores de derechos humanos fueron incomunicados, golpeados y amenazados de muerte el mismo día. En paralelo, cuatro presos políticos salieron libres tras cumplir condena, mientras otros no sobrevivieron bajo custodia.",
    etiqueta: "REPRESIÓN · DEFENSORES DE DERECHOS HUMANOS",
    accent: "#D4BD2B",
    fuentes: "Cubalex · CiberCuba · Martí Noticias · Diario de Cuba · 14ymedio · Cubanet · ADN Cuba",
    publicado: "2026-08-15",
    en: {
      titulo: "The July dragnet",
      subtitulo:
        "On July 2, 2026, State Security launched a simultaneous operation against activists in several provinces to keep them from attending a US Embassy event. Three human rights defenders were held incommunicado, beaten and threatened with death that same day. Meanwhile, four political prisoners were released after serving their sentences, while others did not survive in custody.",
      etiqueta: "REPRESSION · HUMAN RIGHTS DEFENDERS",
      fuentes: "Cubalex · CiberCuba · Martí Noticias · Diario de Cuba · 14ymedio · Cubanet · ADN Cuba",
    },
    load: () => import("./cerco_julio.jsx"),
  },
  {
    id: "negligencia",
    slug: "negligencia",
    path: "/negligencia",
    titulo: "Negligencia criminal o genocidio silencioso",
    subtitulo:
      "Qué categoría resiste los datos cuando se audita la mortalidad cubana 2006-2026",
    etiqueta: "SALUD PÚBLICA · TEST JURÍDICO",
    // Ciruela #7A2B3F, color editorial dominante del renderer (eyebrow, cifras
    // clave, filete de tesis). El círculo está saturado: quedan 6° con
    // racismo-estructural (#A33B4A, h353), del que se separa por 12 puntos de
    // luminosidad (L32 frente a L44). El ámbar #C98A17 de la paleta NO puede
    // salir a portada: el propio dataset lo reserva para lo contrafactual.
    accent: "#7A2B3F",
    fuentes: "ONEI · MINSAP · Horizonte Cubano (Columbia Law) · Health Policy and Planning · Naciones Unidas · prensa independiente",
    publicado: "2026-08-17",
    en: {
      titulo: "Criminal negligence or silent genocide",
      subtitulo:
        "Which category holds up against the data when Cuban mortality 2006-2026 is audited",
      etiqueta: "PUBLIC HEALTH · LEGAL TEST",
      fuentes: "ONEI · MINSAP · Horizonte Cubano (Columbia Law) · Health Policy and Planning · United Nations · independent press",
    },
    load: () => import("./negligencia-o-genocidio.jsx"),
  },
  {
    id: "precio-de-los-cinco",
    slug: "precio-de-los-cinco",
    path: "/precio-de-los-cinco",
    titulo: "El precio de los Cinco",
    subtitulo:
      "Cuánto costó, a cada gobierno, detener, juzgar y encarcelar a cinco agentes de la Red Avispa, y cuánto gastó La Habana en la campaña para traerlos de vuelta. Un modelo con dos libros de cuentas, cada partida con su fuente y su grado de confianza.",
    etiqueta: "RED AVISPA · COSTE DEL CASO",
    // Azul petróleo #0B7FA0 (h193), el color del «libro EE. UU.» del renderer. El óxido del libro
    // Cuba (#B84A2E, h12) no sale a portada: casi coincide con el acento del sitio (#b8562e).
    accent: "#0B7FA0",
    fuentes: "Tribunal federal S.D. Florida · 11.º Circuito · Federal Register (BOP) · Miami Herald · JURIST",
    publicado: "2026-10-19",
    en: {
      titulo: "The price of the Five",
      subtitulo:
        "What it cost each government to arrest, try and imprison five agents of the Wasp Network, and how much Havana spent on the campaign to bring them home. A model with two ledgers, each item with its source and level of confidence.",
      etiqueta: "WASP NETWORK · COST OF THE CASE",
      fuentes: "S.D. Florida federal court · 11th Circuit · Federal Register (BOP) · Miami Herald · JURIST",
    },
    load: () => import("./precio-de-los-cinco.jsx"),
  },
];

export default temas;
